import { render } from "./NotificationMessage.vue?vue&type=template&id=5e694349"
import script from "./NotificationMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/notifications/EnNotificationPanel/NotificationMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e694349"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e694349', __exports__)) {
    api.reload('5e694349', __exports__)
  }
  
  module.hot.accept("./NotificationMessage.vue?vue&type=template&id=5e694349", () => {
    api.rerender('5e694349', render)
  })

}


export default __exports__